/* ════════════════════════════════════════════════════════════
   COVERLAB GARDEN STUDIO v5
   - DOM-based island + flowers (replica annasgarden.dev)
   - Drag & drop on the island
   - Plant target toggle: Garden vs Cover
   - Community gallery (DB-backed via /v1.1/coverlab_garden.php)
   - Tough Case bases (via /v1.1/coverlab_studio_base.php)
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════
     CONSTANTS
  ══════════════════════════════════════════════════════════ */

  var DRAW_COLORS = ['#E74C3C', '#FF8C42', '#FFD166', '#FFB3C1', '#3C7A3B'];

  /* Resolve API base — same logic as coverlab-studio.js so both customizers
     share the same metafield (custom.studio_api_base → window.CLS_API_BASE) */
  function _resolveApiBase() {
    var win = (typeof window !== 'undefined') ? window : {};
    /* explicit per-page override */
    if (win.GS_API_BASE) return String(win.GS_API_BASE).replace(/\/?$/, '/');
    /* shared with main customizer */
    if (win.CLS_API_BASE) return String(win.CLS_API_BASE).replace(/\/?$/, '/');
    /* localhost fallback for dev (MAMP) */
    if (win.location && (win.location.hostname === 'localhost' || win.location.hostname === '127.0.0.1')) {
      return 'http://localhost:8888/v1.1/';
    }
    /* production default — same as coverlab-studio.js */
    return 'https://api.ntngrp.com/v1.1/';
  }

  var API_BASE = _resolveApiBase();
  var API_KEY  = (window.GS_API_KEY || window.CLS_API_KEY || 'njklcj3829u3b');

  var GARDEN_API   = API_BASE + 'coverlab_garden.php';
  var STUDIO_API   = API_BASE + 'coverlab_studio_base.php';

  /* iPhone phone models (Tough Case only) */
  var PHONE_MODELS = [
    { group: 'iPhone 17', models: [
      { id: 'iPhone_17_Pro_Max', name: 'iPhone 17 Pro Max' },
      { id: 'iPhone_17_Pro',     name: 'iPhone 17 Pro'     },
      { id: 'iPhone_17',         name: 'iPhone 17'         },
      { id: 'iPhone_17_Air',     name: 'iPhone 17 Air'     }
    ]},
    { group: 'iPhone 16', models: [
      { id: 'iPhone_16_Pro_Max', name: 'iPhone 16 Pro Max' },
      { id: 'iPhone_16_Pro',     name: 'iPhone 16 Pro'     },
      { id: 'iPhone_16_Plus',    name: 'iPhone 16 Plus'    },
      { id: 'iPhone_16',         name: 'iPhone 16'         }
    ]},
    { group: 'iPhone 15', models: [
      { id: 'iPhone_15_Pro_Max', name: 'iPhone 15 Pro Max' },
      { id: 'iPhone_15_Pro',     name: 'iPhone 15 Pro'     },
      { id: 'iPhone_15_Plus',    name: 'iPhone 15 Plus'    },
      { id: 'iPhone_15',         name: 'iPhone 15'         }
    ]},
    { group: 'iPhone 14', models: [
      { id: 'iPhone_14_Pro_Max', name: 'iPhone 14 Pro Max' },
      { id: 'iPhone_14_Pro',     name: 'iPhone 14 Pro'     },
      { id: 'iPhone_14_Plus',    name: 'iPhone 14 Plus'    },
      { id: 'iPhone_14',         name: 'iPhone 14'         }
    ]}
  ];

  /* ══════════════════════════════════════════════════════════
     STATE
  ══════════════════════════════════════════════════════════ */

  var state = {
    phase:        'garden',
    flowers:      [],            /* { id, dataUrl, dbId?, top%, left%, scale, zIndex } */
    drawColor:    DRAW_COLORS[0],
    brushSize:    9,
    isErasing:    false,
    plantTarget:  'garden',      /* 'garden' | 'cover' */
    phoneModel:   'iPhone_17_Pro',
    baseDesign:   null,          /* { codice_design, name, thumb } */
    customText:   '',
    selectedFont: 'Inter',
    textColor:    '#1a1a1a',
    sessionId:    (function () {
      try {
        var s = localStorage.getItem('gs_session_id');
        if (!s) {
          s = 'gs_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
          localStorage.setItem('gs_session_id', s);
        }
        return s;
      } catch (e) { return 'gs_' + Math.random().toString(36).slice(2, 12); }
    })()
  };

  /* ══════════════════════════════════════════════════════════
     UTILITIES
  ══════════════════════════════════════════════════════════ */

  function rand(min, max) { return min + Math.random() * (max - min); }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function apiUrl(endpoint, params) {
    var url = endpoint + '?keyap=' + encodeURIComponent(API_KEY);
    if (params) Object.keys(params).forEach(function (k) {
      url += '&' + k + '=' + encodeURIComponent(params[k]);
    });
    return url;
  }
  function toAbsoluteUrl(path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    /* When API_BASE is an absolute URL like https://cvrlb.com/v1.1/, use its origin */
    try {
      var u = new URL(API_BASE, location.href);
      if (u.origin && /^https?:/.test(u.protocol)) {
        return u.origin + (path.charAt(0) === '/' ? '' : '/') + path;
      }
    } catch (e) {}
    return path;
  }

  /* ══════════════════════════════════════════════════════════
     ISLAND GENERATOR (fallback only — used if PNG asset fails)
  ══════════════════════════════════════════════════════════ */

  var IslandGen = {
    generate: function () {
      var W = 1200, H = 920;
      var cv = document.createElement('canvas');
      cv.width = W; cv.height = H;
      var ctx = cv.getContext('2d');
      var cx = W / 2, cy = H * 0.5 + 30;
      var rx = W * 0.36, ry = rx * 0.55, depth = ry * 0.55;

      ctx.save();
      ctx.translate(cx + 16, cy + depth + ry * 0.4);
      ctx.scale(1, 0.32);
      var sg = ctx.createRadialGradient(0, 0, 0, 0, 0, rx * 1.1);
      sg.addColorStop(0, 'rgba(0,0,0,0.42)'); sg.addColorStop(0.55, 'rgba(0,0,0,0.22)'); sg.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = sg; ctx.beginPath(); ctx.arc(0, 0, rx * 1.1, 0, Math.PI * 2); ctx.fill();
      ctx.restore();

      var soil = ctx.createLinearGradient(0, cy, 0, cy + depth);
      soil.addColorStop(0, '#7a5a32'); soil.addColorStop(0.45, '#5e4424'); soil.addColorStop(1, '#412c14');
      ctx.fillStyle = soil;
      ctx.beginPath();
      ctx.moveTo(cx - rx, cy);
      ctx.lineTo(cx - rx, cy + depth);
      ctx.bezierCurveTo(cx - rx, cy + depth + ry * 0.55, cx + rx, cy + depth + ry * 0.55, cx + rx, cy + depth);
      ctx.lineTo(cx + rx, cy);
      ctx.bezierCurveTo(cx + rx, cy + ry * 0.55, cx - rx, cy + ry * 0.55, cx - rx, cy);
      ctx.closePath(); ctx.fill();

      var grass = ctx.createRadialGradient(cx - rx * 0.25, cy - ry * 0.5, 0, cx, cy, rx);
      grass.addColorStop(0, '#7ed16e'); grass.addColorStop(0.45, '#4caf50');
      grass.addColorStop(0.85, '#3d7a33'); grass.addColorStop(1, '#2c5722');
      ctx.fillStyle = grass;
      ctx.beginPath(); ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2); ctx.fill();

      var img = document.getElementById('gs-island-img');
      if (img) img.src = cv.toDataURL('image/png');
    }
  };

  /* ══════════════════════════════════════════════════════════
     DRAWING CANVAS
  ══════════════════════════════════════════════════════════ */

  var DrawingCanvas = {
    canvas: null, ctx: null, active: false, pts: [],

    init: function () {
      this.canvas = document.getElementById('gs-draw-canvas');
      if (!this.canvas) return;
      this.ctx = this.canvas.getContext('2d');
      this._clear();
      this._bind();
    },
    _clear: function () { this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height); },
    clear: function () { this._clear(); },

    _bind: function () {
      var self = this, c = this.canvas;
      c.addEventListener('mousedown',  function (e) { self._start(self._pos(e)); });
      c.addEventListener('mousemove',  function (e) { self._draw(self._pos(e)); });
      c.addEventListener('mouseup',    function ()  { self._end(); });
      c.addEventListener('mouseleave', function ()  { self._end(); });
      c.addEventListener('touchstart', function (e) { e.preventDefault(); self._start(self._tpos(e)); }, { passive: false });
      c.addEventListener('touchmove',  function (e) { e.preventDefault(); self._draw(self._tpos(e)); },  { passive: false });
      c.addEventListener('touchend',   function ()  { self._end(); });
    },

    _pos: function (e) {
      var r = this.canvas.getBoundingClientRect();
      return { x: (e.clientX - r.left) * (this.canvas.width / r.width),
               y: (e.clientY - r.top)  * (this.canvas.height / r.height) };
    },
    _tpos: function (e) {
      var r = this.canvas.getBoundingClientRect();
      var t = e.touches[0];
      return { x: (t.clientX - r.left) * (this.canvas.width / r.width),
               y: (t.clientY - r.top)  * (this.canvas.height / r.height) };
    },

    _setStyle: function () {
      var ctx = this.ctx;
      var bs = state.brushSize * 2;
      if (state.isErasing) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.strokeStyle = 'rgba(0,0,0,1)'; ctx.fillStyle = 'rgba(0,0,0,1)';
        ctx.lineWidth = bs * 3.5;
      } else {
        ctx.globalCompositeOperation = 'source-over';
        ctx.strokeStyle = state.drawColor; ctx.fillStyle = state.drawColor;
        ctx.lineWidth = bs;
      }
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    },

    _start: function (p) {
      this.active = true; this.pts = [p, p];
      var ctx = this.ctx; ctx.save(); this._setStyle();
      ctx.beginPath(); ctx.arc(p.x, p.y, ctx.lineWidth / 2, 0, Math.PI * 2); ctx.fill();
      ctx.restore();
    },
    _draw: function (p) {
      if (!this.active) return;
      this.pts.push(p);
      var pts = this.pts;
      if (pts.length < 3) return;
      var ctx = this.ctx;
      var p1 = pts[pts.length - 3], p2 = pts[pts.length - 2], p3 = pts[pts.length - 1];
      var m1x = (p1.x + p2.x) / 2, m1y = (p1.y + p2.y) / 2;
      var m2x = (p2.x + p3.x) / 2, m2y = (p2.y + p3.y) / 2;
      ctx.save(); this._setStyle();
      ctx.beginPath(); ctx.moveTo(m1x, m1y);
      ctx.quadraticCurveTo(p2.x, p2.y, m2x, m2y); ctx.stroke();
      ctx.restore();
    },
    _end: function () { this.active = false; this.pts = []; },

    exportDataUrl: function () {
      var src = this.canvas, ctx = this.ctx;
      var W = src.width, H = src.height;
      var id = ctx.getImageData(0, 0, W, H);
      var d = id.data;
      var minX = W, minY = H, maxX = 0, maxY = 0, found = false;
      for (var y = 0; y < H; y++) {
        for (var x = 0; x < W; x++) {
          if (d[(y * W + x) * 4 + 3] > 8) {
            if (x < minX) minX = x; if (y < minY) minY = y;
            if (x > maxX) maxX = x; if (y > maxY) maxY = y;
            found = true;
          }
        }
      }
      if (!found) return null;
      var pad = 12;
      minX = Math.max(0, minX - pad); minY = Math.max(0, minY - pad);
      maxX = Math.min(W - 1, maxX + pad); maxY = Math.min(H - 1, maxY + pad);
      var cw = maxX - minX, ch = maxY - minY;
      var out = document.createElement('canvas');
      out.width = cw; out.height = ch;
      out.getContext('2d').drawImage(src, minX, minY, cw, ch, 0, 0, cw, ch);
      return out.toDataURL('image/png');
    },

    isEmpty: function () {
      var d = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height).data;
      for (var i = 3; i < d.length; i += 4) if (d[i] > 8) return false;
      return true;
    }
  };

  /* ══════════════════════════════════════════════════════════
     GARDEN — DOM-based flower placement + drag & drop
  ══════════════════════════════════════════════════════════ */

  var Garden = {
    container: null,

    init: function () {
      this.container = document.getElementById('gs-flowers');
      var img = document.getElementById('gs-island-img');
      if (img) img.addEventListener('error', function () { IslandGen.generate(); });
    },

    /* Plant a freshly drawn or community-picked flower */
    plant: function (dataUrl, opts) {
      opts = opts || {};
      var top  = rand(2, 65);
      var left = rand(13, 72);
      var scaleBase = 0.5 + (top / 100) * 0.4;
      var scale     = scaleBase + Math.random() * 0.05;
      var zIndex    = Math.round(top);

      var flower = {
        id:      Date.now() + Math.random(),
        dataUrl: dataUrl,
        dbId:    opts.dbId || null,
        top:     top,
        left:    left,
        scale:   scale,
        zIndex:  zIndex
      };
      state.flowers.push(flower);
      this._renderFlower(flower, state.flowers.length - 1);
      UI.updateCount();
      if (state.plantTarget === 'cover') CoverPreview.refreshFlowers();
      return flower;
    },

    _renderFlower: function (f, idx) {
      var wrap = document.createElement('div');
      wrap.className = 'gs-flower';
      wrap.dataset.idx = idx;
      wrap.style.left = f.left + '%';
      wrap.style.top  = f.top + '%';
      wrap.style.transform = 'scale(' + f.scale + ')';
      wrap.style.zIndex = f.zIndex;

      var inner = document.createElement('div');
      inner.className = 'gs-flower__inner';
      inner.style.animationDelay = (idx * 0.05) + 's';

      var img = document.createElement('img');
      img.className = 'gs-flower__img';
      img.alt = 'Flower ' + (idx + 1);
      img.src = f.dataUrl;
      img.draggable = false;

      inner.appendChild(img);
      wrap.appendChild(inner);
      this.container.appendChild(wrap);

      this._makeDraggable(wrap, f);
    },

    /* Make a planted flower draggable across the island */
    _makeDraggable: function (el, flower) {
      Garden._makeFlowerInteractive(el, flower, document.getElementById('gs-island'), 'garden');
    },

    /* Generic interactive handler:
       - drag (mouse + 1 finger touch)
       - resize (mouse wheel + pinch with 2 fingers)
       mode: 'garden' (uses flower.left/top/scale) | 'cover' (uses flower.coverLeft/coverTop/coverScale) */
    _makeFlowerInteractive: function (el, flower, container, mode) {
      var isCover = (mode === 'cover');
      var fLeft  = isCover ? 'coverLeft'  : 'left';
      var fTop   = isCover ? 'coverTop'   : 'top';
      var fScale = isCover ? 'coverScale' : 'scale';

      function getLeft()  { return flower[fLeft]  != null ? flower[fLeft]  : (isCover ? Garden._defaultCoverPos(flower).left  : flower.left);  }
      function getTop()   { return flower[fTop]   != null ? flower[fTop]   : (isCover ? Garden._defaultCoverPos(flower).top   : flower.top);   }
      function getScale() { return flower[fScale] != null ? flower[fScale] : (isCover ? Garden._defaultCoverScale(flower)     : flower.scale); }

      var minBoundLeft = -5,  maxBoundLeft = 95;
      var minBoundTop  = -10, maxBoundTop  = 88;
      if (isCover) {
        /* Tighter bounds inside the case */
        minBoundLeft = 0; maxBoundLeft = 90;
        minBoundTop  = 0; maxBoundTop  = 95;
      }
      var minScale = 0.25, maxScale = 2.5;

      /* Global "click outside" deselect — registered once per page load */
      if (!window.__gsFlowerDeselectBound) {
        window.__gsFlowerDeselectBound = true;
        document.addEventListener('mousedown', function (e) {
          if (e.target.closest && e.target.closest('.gs-flower')) return;
          document.querySelectorAll('.gs-flower.is-selected').forEach(function (n) { n.classList.remove('is-selected'); });
        }, true);
        document.addEventListener('touchstart', function (e) {
          if (e.target.closest && e.target.closest('.gs-flower')) return;
          document.querySelectorAll('.gs-flower.is-selected').forEach(function (n) { n.classList.remove('is-selected'); });
        }, { capture: true, passive: true });
      }

      /* Select this flower on press (drag still works) */
      function selectThis() {
        document.querySelectorAll('.gs-flower.is-selected').forEach(function (n) { if (n !== el) n.classList.remove('is-selected'); });
        el.classList.add('is-selected');
      }
      el.addEventListener('mousedown', selectThis);
      el.addEventListener('touchstart', selectThis, { passive: true });

      /* Inject +/- zoom controls (visible alternative to wheel/pinch) */
      if (!el.querySelector('.gs-flower__zoom')) {
        var zoomWrap = document.createElement('div');
        zoomWrap.className = 'gs-flower__zoom';
        zoomWrap.innerHTML =
          '<button type="button" class="gs-flower__zoom-btn gs-flower__zoom-btn--minus" aria-label="' + ((window.GS_I18N||{}).zoom_out||'Zoom out') + '">−</button>' +
          '<button type="button" class="gs-flower__zoom-btn gs-flower__zoom-btn--plus" aria-label="' + ((window.GS_I18N||{}).zoom_in||'Zoom in') + '">+</button>';
        el.appendChild(zoomWrap);
        var bumpScale = function (delta) {
          var ns = clamp(getScale() + delta, minScale, maxScale);
          flower[fScale] = ns;
          el.style.transform = 'scale(' + ns + ')';
          if (state.plantTarget === 'cover' && !isCover) CoverPreview.refreshFlowers();
        };
        var bind = function (btn, delta) {
          ['mousedown','touchstart'].forEach(function (ev) {
            btn.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: false });
          });
          ['click','touchend'].forEach(function (ev) {
            btn.addEventListener(ev, function (e) {
              e.stopPropagation();
              if (e.cancelable) e.preventDefault();
              bumpScale(delta);
            });
          });
        };
        bind(zoomWrap.querySelector('.gs-flower__zoom-btn--minus'), -0.15);
        bind(zoomWrap.querySelector('.gs-flower__zoom-btn--plus'),  +0.15);
      }

      var startX, startY, startLeft, startTop;
      var dragging = false;
      /* Pinch state */
      var pinching = false, pinchStartDist = 0, pinchStartScale = 1;

      function pos(e) {
        var t = (e.touches && e.touches[0]) || e;
        return { x: t.clientX, y: t.clientY };
      }
      function pinchDist(e) {
        if (!e.touches || e.touches.length < 2) return 0;
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      function startInteraction() {
        var bob = document.querySelector('.gs-stage-bob');
        if (bob) bob.classList.add('is-interacting');
      }
      function endInteraction() {
        var bob = document.querySelector('.gs-stage-bob');
        if (bob) bob.classList.remove('is-interacting');
      }

      function onDown(e) {
        if (e.touches && e.touches.length === 2) {
          /* Start pinch instead of drag */
          pinching = true; dragging = false;
          pinchStartDist = pinchDist(e);
          pinchStartScale = getScale();
          startInteraction();
          if (e.cancelable) e.preventDefault();
          document.addEventListener('touchmove', onMove, { passive: false });
          document.addEventListener('touchend', onUp);
          return;
        }
        var p = pos(e);
        startX = p.x; startY = p.y;
        startLeft = getLeft(); startTop = getTop();
        dragging = true; pinching = false;
        el.classList.add('gs-flower--dragging');
        el.style.zIndex = 999;
        startInteraction();
        if (e.cancelable) e.preventDefault();
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onUp);
      }

      function onMove(e) {
        if (e.cancelable) e.preventDefault();
        /* Pinch-to-resize on touch devices */
        if (e.touches && e.touches.length === 2) {
          if (!pinching) { pinching = true; pinchStartDist = pinchDist(e); pinchStartScale = getScale(); return; }
          var d = pinchDist(e);
          if (pinchStartDist > 0) {
            var ns = clamp(pinchStartScale * (d / pinchStartDist), minScale, maxScale);
            flower[fScale] = ns;
            applyTransform();
          }
          return;
        }

        if (!dragging) return;
        var p = pos(e);
        var rect = container.getBoundingClientRect();
        var dxPct = ((p.x - startX) / rect.width)  * 100;
        var dyPct = ((p.y - startY) / rect.height) * 100;
        var nl = clamp(startLeft + dxPct, minBoundLeft, maxBoundLeft);
        var nt = clamp(startTop  + dyPct, minBoundTop,  maxBoundTop);
        flower[fLeft] = nl; flower[fTop] = nt;
        el.style.left = nl + '%';
        el.style.top  = nt + '%';
      }

      function onUp() {
        if (!dragging && !pinching) return;
        dragging = false; pinching = false;
        if (!isCover) {
          /* Garden mode: re-derive z-index based on top% (lower = closer) */
          flower.zIndex = Math.round(flower.top);
          el.style.zIndex = flower.zIndex;
        }
        applyTransform();
        el.classList.remove('gs-flower--dragging');
        endInteraction();
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onUp);
        if (state.plantTarget === 'cover' && !isCover) CoverPreview.refreshFlowers();
      }

      function applyTransform() {
        el.style.transform = 'scale(' + getScale() + ')';
      }

      /* Wheel for desktop resize */
      function onWheel(e) {
        e.preventDefault();
        var cur = getScale();
        var delta = -e.deltaY * 0.0015;
        var ns = clamp(cur + delta, minScale, maxScale);
        flower[fScale] = ns;
        applyTransform();
      }

      el.addEventListener('mousedown',  onDown);
      el.addEventListener('touchstart', onDown, { passive: false });
      el.addEventListener('wheel',      onWheel, { passive: false });
    },

    _defaultCoverPos: function (f) {
      var lx = clamp(f.left, 0, 95) / 95;
      var ly = clamp(f.top,  0, 88) / 88;
      return { left: 10 + lx * 80, top: 12 + ly * 76 };
    },
    _defaultCoverScale: function (f) {
      // Medio-grande di default: 1.4 (era ~0.85). L'utente puo' regolare con +/- o pinch.
      return 1.4;
    },

    rerenderAll: function () {
      this.container.innerHTML = '';
      var self = this;
      state.flowers.forEach(function (f, i) { self._renderFlower(f, i); });
    },

    clear: function () {
      state.flowers = [];
      this.container.innerHTML = '';
      UI.updateCount();
      CoverPreview.refreshFlowers();
    },

    /* Flatten the entire garden (island + flowers) to a single PNG */
    exportFlat: function () {
      var island = document.getElementById('gs-island');
      var rect = island.getBoundingClientRect();
      var dpr = 2;
      var W = Math.round(rect.width * dpr), H = Math.round(rect.height * dpr);
      var cv = document.createElement('canvas');
      cv.width = W; cv.height = H;
      var ctx = cv.getContext('2d');
      var islandImg = document.getElementById('gs-island-img');

      return new Promise(function (resolve) {
        var doExport = function () {
          ctx.drawImage(islandImg, 0, 0, W, H);
          var flowers = state.flowers.slice().sort(function (a, b) { return a.zIndex - b.zIndex; });
          var loaded = 0, total = flowers.length;
          if (total === 0) { resolve(cv.toDataURL('image/png')); return; }
          flowers.forEach(function (f) {
            var img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () {
              var fSize = 100 * f.scale * dpr;
              var fAR = img.width / img.height;
              var fW = fSize * fAR, fH = fSize;
              var fx = (f.left / 100) * W, fy = (f.top / 100) * H;
              ctx.drawImage(img, fx, fy, fW, fH);
              loaded++;
              if (loaded === total) resolve(cv.toDataURL('image/png'));
            };
            img.onerror = function () {
              loaded++;
              if (loaded === total) resolve(cv.toDataURL('image/png'));
            };
            img.src = f.dataUrl;
          });
        };
        if (islandImg.complete && islandImg.naturalWidth) doExport();
        else islandImg.onload = doExport;
      });
    }
  };

  /* ══════════════════════════════════════════════════════════
     COVER PREVIEW — inline preview shown in place of the island
     when plant target = "cover".
  ══════════════════════════════════════════════════════════ */

  var CoverPreview = {
    wrap: null, baseImg: null, flowersEl: null,
    controlsEl: null, modelSelect: null, basesEl: null,
    _bases: null, _selectedBase: null, _modelInited: false,

    init: function () {
      this.wrap        = document.getElementById('gs-island-wrap');
      this.baseImg     = document.getElementById('gs-cover-preview-base');
      this.flowersEl   = document.getElementById('gs-cover-preview-flowers');
      this.controlsEl  = document.getElementById('gs-cover-controls');
      this.modelSelect = document.getElementById('gs-cover-mini-model');
      this.basesEl     = document.getElementById('gs-cover-mini-bases');
      this._renderModelSelect();
      this._bind();
    },

    _renderModelSelect: function () {
      if (!this.modelSelect || this._modelInited) return;
      var sel = this.modelSelect;
      sel.innerHTML = '';
      PHONE_MODELS.forEach(function (g) {
        var og = document.createElement('optgroup');
        og.label = g.group;
        g.models.forEach(function (m) {
          var opt = document.createElement('option');
          opt.value = m.id;
          opt.textContent = m.name;
          if (m.id === state.phoneModel) opt.selected = true;
          og.appendChild(opt);
        });
        sel.appendChild(og);
      });
      this._modelInited = true;
    },

    _bind: function () {
      var self = this;
      if (this.modelSelect) {
        this.modelSelect.addEventListener('change', function () {
          state.phoneModel = self.modelSelect.value;
          /* Reload bases for the new model size */
          self._bases = null;
          self._loadBases().then(function () {
            /* Keep the previously selected base if available, else first */
            var prev = self._selectedBase;
            var match = prev && self._bases.filter(function (b) { return b.codice_design === prev.codice_design; })[0];
            var floral = self._bases.filter(function (b) { return ['290','9075','9109','9116'].indexOf(String(b.codice_design)) >= 0; })[0];
            self._selectBase(match || floral || self._bases[0] || null);
          });
        });
      }
    },

    /* Fetch the curated tough bases for the current phone model */
    _loadBases: function () {
      var self = this;
      var url = apiUrl(STUDIO_API, { action: 'tough_bases', cmt_size: state.phoneModel });
      return fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var bases = (d && d.bases) ? d.bases : [];
          var allowed = (window.GS_BASE_CODES && window.GS_BASE_CODES.length) ? window.GS_BASE_CODES : null;
          if (allowed) bases = bases.filter(function (b) { return allowed.indexOf(b.codice_design) !== -1; });
          else         bases = bases.slice(0, 6);
          self._bases = bases;
          self._renderBaseGrid();
          return bases;
        })
        .catch(function () { self._bases = []; self._renderBaseGrid(); return self._bases; });
    },

    _renderBaseGrid: function () {
      if (!this.basesEl) return;
      var self = this;
      this.basesEl.innerHTML = '';
      if (!this._bases || this._bases.length === 0) {
        this.basesEl.innerHTML = '<span style="font-size:11px;color:#9a9a9a">No bases available</span>';
        return;
      }
      this._bases.forEach(function (b) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gs-cover-mini-base' + (self._selectedBase && self._selectedBase.codice_design === b.codice_design ? ' active' : '');
        btn.dataset.codice = b.codice_design;
        btn.title = b.name || ('Design ' + b.codice_design);
        var img = document.createElement('img');
        img.src = b.thumb; img.alt = b.name || ''; img.loading = 'lazy';
        btn.appendChild(img);
        btn.addEventListener('click', function () { self._selectBase(b); });
        self.basesEl.appendChild(btn);
      });
    },

    _selectBase: function (b) {
      this._selectedBase = b;
      state.baseDesign = b;
      if (this.baseImg && b) {
        // Usa la base renderizzata (con foro fotocamera) invece del design statico (senza foro).
        var _self = this;
        var _u = apiUrl(STUDIO_API, { action: 'render_tough_base', codice_design: b.codice_design, cmt_size: state.phoneModel });
        fetch(_u).then(function (r) { return r.json(); }).then(function (d) {
          if (d && d.image) _self.baseImg.src = d.image;
          else if (b.thumb) _self.baseImg.src = b.thumb;
        }).catch(function () { if (b.thumb) _self.baseImg.src = b.thumb; });
      }
      /* Update active styling on grid */
      if (this.basesEl) {
        Array.prototype.forEach.call(this.basesEl.querySelectorAll('.gs-cover-mini-base'), function (n) { n.classList.remove('active'); });
        if (b) {
          var act = this.basesEl.querySelector('.gs-cover-mini-base[data-codice="' + b.codice_design + '"]');
          if (act) act.classList.add('active');
        }
      }
    },

    /* Show preview, load bases if needed, refresh flowers */
    show: function () {
      var self = this;
      if (!this.wrap) return;
      this.wrap.classList.add('is-cover-mode');
      this.refreshFlowers();
      if (!this._bases) {
        this._loadBases().then(function () {
          var floral = self._bases.filter(function (b) { return ['290','9075','9109','9116'].indexOf(String(b.codice_design)) >= 0; })[0];
          self._selectBase(floral || self._bases[0] || null);
        });
      }
    },

    hide: function () {
      if (!this.wrap) return;
      this.wrap.classList.remove('is-cover-mode');
    },

    /* Re-render flowers from state into the preview.
       Uses per-flower coverLeft/coverTop/coverScale if defined (set by user
       interaction in cover mode), otherwise maps from garden coordinates. */
    refreshFlowers: function () {
      if (!this.flowersEl) return;
      var preview = document.getElementById('gs-cover-preview');
      this.flowersEl.innerHTML = '';
      state.flowers.forEach(function (f, idx) {
        var defaults = Garden._defaultCoverPos(f);
        var leftPct  = (f.coverLeft  != null) ? f.coverLeft  : defaults.left;
        var topPct   = (f.coverTop   != null) ? f.coverTop   : defaults.top;
        var scale    = (f.coverScale != null) ? f.coverScale : Garden._defaultCoverScale(f);

        var wrap = document.createElement('div');
        wrap.className = 'gs-flower';
        wrap.style.left = leftPct + '%';
        wrap.style.top  = topPct + '%';
        wrap.style.transform = 'scale(' + scale + ')';
        wrap.style.zIndex = idx + 1;

        var inner = document.createElement('div');
        inner.className = 'gs-flower__inner';
        inner.style.animationDelay = (idx * 0.04) + 's';

        var img = document.createElement('img');
        img.className = 'gs-flower__img';
        img.alt = 'Flower ' + (idx + 1);
        img.src = f.dataUrl;
        img.draggable = false;

        inner.appendChild(img);
        wrap.appendChild(inner);
        CoverPreview.flowersEl.appendChild(wrap);

        /* Make it draggable + resizable (wheel + pinch) */
        Garden._makeFlowerInteractive(wrap, f, preview, 'cover');
      });
    }
  };

  /* ══════════════════════════════════════════════════════════
     COMMUNITY MODULE
  ══════════════════════════════════════════════════════════ */

  var Community = {
    flowers: [],
    page: 0, pageSize: 24, total: 0,
    grid: null, loadMoreBtn: null, countEl: null,

    init: function () {
      this.grid       = document.getElementById('gs-community-grid');
      this.loadMoreBtn = document.getElementById('gs-community-load-more');
      this.countEl    = document.getElementById('gs-community-count');
      var self = this;
      if (this.loadMoreBtn) this.loadMoreBtn.addEventListener('click', function () { self.loadMore(); });
      this.load();
    },

    load: function () {
      var self = this;
      var url = apiUrl(GARDEN_API, { action: 'list', limit: this.pageSize, offset: 0 });
      fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          var ct = r.headers.get('content-type') || '';
          if (ct.indexOf('application/json') === -1) throw new Error('Not JSON');
          return r.json();
        })
        .then(function (d) {
          if (!d || !d.success) { self._renderEmpty('Could not load flowers (' + (d && d.error ? d.error : 'unknown') + ').'); return; }
          self.flowers = d.flowers || [];
          self.total = d.total || self.flowers.length;
          self.page = 1;
          self._render();
        })
        .catch(function (err) {
          /* eslint-disable no-console */
          if (window.console && console.warn) console.warn('[GardenStudio] community load failed:', err, 'API:', GARDEN_API);
          self._renderEmpty('Community garden is offline. Try again later. 🌱');
        });
    },

    loadMore: function () {
      var self = this;
      var offset = this.page * this.pageSize;
      var url = apiUrl(GARDEN_API, { action: 'list', limit: this.pageSize, offset: offset });
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d.success) return;
          self.flowers = self.flowers.concat(d.flowers || []);
          self.page += 1;
          self._render();
        });
    },

    _render: function () {
      if (!this.grid) return;
      var self = this;
      this.grid.innerHTML = '';
      if (this.flowers.length === 0) {
        this._renderEmpty('No flowers yet — be the first to plant one! 🌷');
        return;
      }
      this.flowers.forEach(function (f) {
        var btn = document.createElement('button');
        btn.className = 'gs-community-item';
        btn.dataset.id = f.id;
        btn.title = (f.creator_name || ((window.GS_I18N||{}).anon_gardener||'Anonymous gardener')) + ' · used ' + (f.usage_count || 0) + 'x';
        btn.setAttribute('aria-label', ((window.GS_I18N||{}).add_to_garden||'Add to garden'));
        var img = document.createElement('img');
        img.src = toAbsoluteUrl(f.image_url);
        img.alt = ((window.GS_I18N||{}).community_flower||'Community flower');
        img.loading = 'lazy';
        btn.appendChild(img);
        var add = document.createElement('span');
        add.className = 'gs-community-item__add'; add.textContent = '+';
        btn.appendChild(add);
        btn.addEventListener('click', function () { self._add(f); });
        self.grid.appendChild(btn);
      });
      if (this.countEl) this.countEl.textContent = this.flowers.length + ' / ' + this.total + ' flowers';
      if (this.loadMoreBtn) this.loadMoreBtn.style.display = (this.flowers.length < this.total) ? '' : 'none';
    },

    _renderEmpty: function (msg) {
      if (!this.grid) return;
      this.grid.innerHTML = '<p class="gs-community__empty">' + msg + '</p>';
      if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'none';
    },

    _add: function (f) {
      var url = toAbsoluteUrl(f.image_url);
      /* For community flowers we can use the URL directly (CORS-safe same-origin) */
      Garden.plant(url, { dbId: f.id });
      /* Bump usage counter (fire & forget) */
      try {
        fetch(apiUrl(GARDEN_API, { action: 'increment_usage', id: f.id }));
      } catch (e) {}
    },

    /* Save a freshly drawn flower to the community DB */
    save: function (dataUrl, creatorName) {
      var body = JSON.stringify({
        image_data:   dataUrl,
        creator_name: creatorName || '',
        session_id:   state.sessionId
      });
      return fetch(apiUrl(GARDEN_API, { action: 'create' }), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      }).then(function (r) { return r.json(); }).catch(function () { return null; });
    }
  };

  /* ══════════════════════════════════════════════════════════
     COVER BUILDER (Konva.js)
  ══════════════════════════════════════════════════════════ */

  var Cover = {
    stage: null, bgLayer: null, printLayer: null, uiLayer: null,
    transformer: null, caseShape: null, baseImg: null, printBounds: null,
    _bound: false, _bases: null,

    init: function () {
      var el = document.getElementById('gs-cover-canvas');
      this.stage = new Konva.Stage({ container: 'gs-cover-canvas', width: el.offsetWidth, height: el.offsetHeight });
      this.bgLayer = new Konva.Layer();
      this.printLayer = new Konva.Layer();
      this.uiLayer = new Konva.Layer();
      this.stage.add(this.bgLayer, this.printLayer, this.uiLayer);

      this.transformer = new Konva.Transformer({
        borderStroke: '#166534', borderStrokeWidth: 1.5,
        anchorStroke: '#166534', anchorFill: '#ffffff',
        anchorSize: 10, anchorCornerRadius: 5,
        rotateAnchorOffset: 24,
        enabledAnchors: ['top-left','top-right','bottom-left','bottom-right'],
        keepRatio: true, padding: 4
      });
      this.uiLayer.add(this.transformer);

      var self = this;
      this.stage.on('tap click', function (e) {
        if (e.target === self.stage) {
          self.transformer.nodes([]); self.uiLayer.batchDraw();
          document.getElementById('gs-delete-selected').style.display = 'none';
        }
      });
      this.drawPhone();
      if (!this._bound) { this._bind(); this._bound = true; }
      this.loadBases();
    },

    drawPhone: function () {
      this.bgLayer.destroyChildren();
      var W = this.stage.width(), H = this.stage.height();
      var pH = H * 0.83, pW = pH * 0.464;
      var ox = (W - pW) / 2, oy = (H - pH) / 2;
      var rad = pW * 0.115, pad = pW * 0.04;
      this.printBounds = { x: ox + pad, y: oy + pad, w: pW - pad * 2, h: pH - pad * 2 };

      var sh = new Konva.Rect({ x: ox + 5, y: oy + 10, width: pW, height: pH, cornerRadius: rad, fill: '#1a1a1a', opacity: 0.1, filters: [Konva.Filters.Blur], blurRadius: 20, listening: false });
      sh.cache(); this.bgLayer.add(sh);

      this.caseShape = new Konva.Rect({ x: ox, y: oy, width: pW, height: pH, cornerRadius: rad, fill: '#ffffff', stroke: '#ccc9c4', strokeWidth: 1, listening: false });
      this.bgLayer.add(this.caseShape);

      var bc = '#bbb9b4';
      this.bgLayer.add(new Konva.Rect({ x: ox + pW - 1, y: oy + pH * 0.22, width: 3, height: pH * 0.1, cornerRadius: 1.5, fill: bc, listening: false }));
      this.bgLayer.add(new Konva.Rect({ x: ox - 2, y: oy + pH * 0.2, width: 3, height: pH * 0.07, cornerRadius: 1.5, fill: bc, listening: false }));
      this.bgLayer.add(new Konva.Rect({ x: ox - 2, y: oy + pH * 0.3, width: 3, height: pH * 0.1, cornerRadius: 1.5, fill: bc, listening: false }));
      this.bgLayer.add(new Konva.Rect({ x: ox + pW * 0.58, y: oy + pH * 0.022, width: pW * 0.35, height: pH * 0.12, cornerRadius: rad * 0.45, fill: 'rgba(0,0,0,0.04)', stroke: '#bbb9b4', strokeWidth: 0.8, listening: false }));

      this.bgLayer.batchDraw();

      this.printLayer.clip({ x: this.printBounds.x, y: this.printBounds.y, width: this.printBounds.w, height: this.printBounds.h });
      this.printLayer._printBounds = this.printBounds;

      /* Re-apply selected base if any */
      if (this.baseImg) this._renderBase();
    },

    /* Allowed Tough base codes for Garden Studio (curated subset).
       Override at runtime via window.GS_BASE_CODES = ['277', '...']. */
    _allowedBaseCodes: function () {
      if (window.GS_BASE_CODES && window.GS_BASE_CODES.length) return window.GS_BASE_CODES;
      /* Default: first 6 returned by the API (will be replaced when we have the
         curated list — see TODO at the bottom of this file) */
      return null;
    },

    /* Load Tough Case base designs from existing v1.1 API.
       Returns a Promise that resolves with the bases array. */
    loadBases: function () {
      var self = this;
      if (this._bases) { this._renderBaseGrid(); return Promise.resolve(this._bases); }
      var url = apiUrl(STUDIO_API, { action: 'tough_bases', cmt_size: state.phoneModel });
      return fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var bases = (d && d.bases) ? d.bases : [];
          var allowed = self._allowedBaseCodes();
          if (allowed) {
            bases = bases.filter(function (b) { return allowed.indexOf(b.codice_design) !== -1; });
          } else {
            bases = bases.slice(0, 6);
          }
          self._bases = bases;
          self._renderBaseGrid();
          return self._bases;
        })
        .catch(function () { self._bases = []; self._renderBaseGrid(); return self._bases; });
    },

    _renderBaseGrid: function () {
      var el = document.getElementById('gs-base-designs');
      if (!el) return;
      el.innerHTML = '';
      var self = this;
      if (!this._bases || this._bases.length === 0) {
        el.innerHTML = '<p style="font-size:11px;color:#9a9a9a;margin:0">No base designs available.</p>';
        return;
      }
      this._bases.forEach(function (b) {
        var btn = document.createElement('button');
        btn.className = 'gs-base-thumb' + (state.baseDesign && state.baseDesign.codice_design === b.codice_design ? ' active' : '');
        btn.dataset.codice = b.codice_design;
        btn.title = b.name || b.codice_design;
        var img = document.createElement('img');
        img.src = b.thumb;
        img.alt = b.name || 'Tough Base';
        img.loading = 'lazy';
        btn.appendChild(img);
        var nm = document.createElement('span');
        nm.className = 'gs-base-thumb__name';
        nm.textContent = (b.name || b.codice_design).slice(0, 14);
        btn.appendChild(nm);
        btn.addEventListener('click', function () { self.selectBase(b); });
        el.appendChild(btn);
      });
    },

    selectBase: function (b) {
      state.baseDesign = b;
      var self = this;
      document.querySelectorAll('.gs-base-thumb').forEach(function (n) { n.classList.remove('active'); });
      var act = document.querySelector('.gs-base-thumb[data-codice="' + b.codice_design + '"]');
      if (act) act.classList.add('active');

      /* Render the base on canvas — base renderizzata CON foro fotocamera (data URL),
         fallback al design statico b.thumb (senza foro) solo se l'endpoint fallisce. */
      var _loadOnCanvas = function (src) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          self.baseImg = img;
          self._renderBase();
          document.getElementById('gs-add-to-cart').disabled = false;
        };
        img.onerror = function () { if (src !== b.thumb && b.thumb) _loadOnCanvas(b.thumb); };
        img.src = src;
      };
      var url = apiUrl(STUDIO_API, { action: 'render_tough_base', codice_design: b.codice_design, cmt_size: state.phoneModel });
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.image) _loadOnCanvas(d.image);
        else if (b.thumb) _loadOnCanvas(b.thumb);
      }).catch(function () { if (b.thumb) _loadOnCanvas(b.thumb); });
    },

    _renderBase: function () {
      if (!this.baseImg || !this.printBounds) return;
      /* Remove any existing base node, keep stickers/text */
      var children = this.printLayer.getChildren();
      for (var i = children.length - 1; i >= 0; i--) {
        if (children[i]._isBase) children[i].destroy();
      }
      var b = this.printBounds;
      var imgAR = this.baseImg.width / this.baseImg.height;
      var areaAR = b.w / b.h;
      var dw, dh, dx, dy;
      if (imgAR > areaAR) {
        dh = b.h; dw = dh * imgAR; dx = b.x - (dw - b.w) / 2; dy = b.y;
      } else {
        dw = b.w; dh = dw / imgAR; dx = b.x; dy = b.y - (dh - b.h) / 2;
      }
      var node = new Konva.Image({ x: dx, y: dy, width: dw, height: dh, image: this.baseImg, listening: false });
      node._isBase = true;
      /* Insert at the bottom of the print layer */
      this.printLayer.add(node);
      node.moveToBottom();
      this.printLayer.batchDraw();
    },

    /* Used when transitioning from garden with a flat-garden bg */
    loadBackground: function (dataUrl) {
      var self = this;
      var img = new Image();
      img.onload = function () {
        var b = self.printBounds;
        var imgAR = img.width / img.height;
        var areaAR = b.w / b.h;
        var dw, dh, dx, dy;
        if (imgAR > areaAR) {
          dh = b.h; dw = dh * imgAR; dx = b.x - (dw - b.w) / 2; dy = b.y;
        } else {
          dw = b.w; dh = dw / imgAR; dx = b.x; dy = b.y - (dh - b.h) / 2;
        }
        /* Remove other base if any */
        var children = self.printLayer.getChildren();
        for (var i = children.length - 1; i >= 0; i--) {
          if (children[i]._isBase) children[i].destroy();
        }
        var node = new Konva.Image({ x: dx, y: dy, width: dw, height: dh, image: img, listening: false });
        node._isBase = true;
        self.printLayer.add(node);
        node.moveToBottom();
        self.printLayer.batchDraw();
        document.getElementById('gs-add-to-cart').disabled = false;
      };
      img.src = dataUrl;
    },

    /* Add a flower as a movable sticker.
       opts (optional):
         - leftPct, topPct: 0-100 → preserves garden position (relative to print bounds)
         - scale:           garden flower scale (≈ 0.5–0.95) → maps to sticker size
         - rotation:        degrees
         - select:          whether to auto-select the new node (default true) */
    addFlowerSticker: function (dataUrl, opts) {
      opts = opts || {};
      var self = this;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var b = self.printBounds;
        var nat = Math.max(img.width, img.height);
        /* Garden flowers on the island are 100px @ scale 1.0; the island wrap is ~600px wide.
           So a flower covers roughly 17% of the island width.
           When we move to the cover, mirror that ratio over the print bound width. */
        var sizeRatio = (typeof opts.scale === 'number') ? (opts.scale * 0.34) : 0.32;
        var dim = b.w * sizeRatio;
        var w = dim * (img.width / nat), h = dim * (img.height / nat);

        var x, y;
        if (typeof opts.leftPct === 'number' && typeof opts.topPct === 'number') {
          /* Map garden coords (0-95% left, 0-88% top) to a comfortable area
             inside the print bound: 10-90% horizontally, 12-88% vertically. */
          var lx = clamp(opts.leftPct, 0, 95) / 95;     /* 0..1 */
          var ly = clamp(opts.topPct,  0, 88) / 88;
          x = b.x + b.w * (0.10 + lx * 0.80);
          y = b.y + b.h * (0.12 + ly * 0.76);
        } else {
          x = b.x + b.w * 0.2 + Math.random() * b.w * 0.5;
          y = b.y + b.h * 0.2 + Math.random() * b.h * 0.6;
        }
        var rot = (typeof opts.rotation === 'number') ? opts.rotation : (Math.random() - 0.5) * 16;

        var node = new Konva.Image({
          x: x, y: y, width: w, height: h, image: img, draggable: true,
          offsetX: w / 2, offsetY: h / 2, rotation: rot
        });
        node.on('tap click', function () {
          self.transformer.nodes([node]); self.uiLayer.batchDraw();
          document.getElementById('gs-delete-selected').style.display = 'flex';
        });
        self.printLayer.add(node);
        self.printLayer.batchDraw();
        if (opts.select !== false) {
          self.transformer.nodes([node]); self.uiLayer.batchDraw();
          document.getElementById('gs-delete-selected').style.display = 'flex';
        }
        document.getElementById('gs-add-to-cart').disabled = false;
      };
      img.src = dataUrl;
    },

    /* Convenience: dump every flower from the garden as a sticker, preserving
       the cover-mode positions if the user customized them in the inline preview,
       otherwise fall back to the garden positions mapped into the print bound. */
    addAllGardenFlowers: function () {
      var self = this;
      state.flowers.forEach(function (f) {
        var hasCoverPos = (f.coverLeft != null && f.coverTop != null);
        var leftPct, topPct, scale;
        if (hasCoverPos) {
          /* coverLeft/coverTop are in 0-100 of preview; the addFlowerSticker
             below applies its own (10-90, 12-88) re-mapping. So we feed it
             "garden coords" inverted from cover coords. */
          var lx = clamp(f.coverLeft - 10, 0, 80) / 80;     /* 0..1 within (10..90) */
          var ly = clamp(f.coverTop  - 12, 0, 76) / 76;
          leftPct = lx * 95;     /* 0..95 (the garden range) */
          topPct  = ly * 88;     /* 0..88 */
          scale   = (f.coverScale != null) ? (f.coverScale / 0.95) : f.scale;
        } else {
          leftPct = f.left; topPct = f.top; scale = f.scale;
        }
        self.addFlowerSticker(f.dataUrl, {
          leftPct:  leftPct,
          topPct:   topPct,
          scale:    scale,
          rotation: 0,
          select:   false
        });
      });
    },

    addText: function (text, font, color) {
      if (!text.trim()) return;
      var b = this.printBounds, self = this;
      var node = new Konva.Text({
        x: b.x + b.w / 2, y: b.y + b.h * 0.72,
        text: text, fontSize: 24,
        fontFamily: font || 'Inter', fill: color || '#1a1a1a',
        align: 'center', draggable: true
      });
      node.offsetX(node.width() / 2);
      node.on('tap click', function () {
        self.transformer.nodes([node]); self.uiLayer.batchDraw();
        document.getElementById('gs-delete-selected').style.display = 'flex';
      });
      this.printLayer.add(node);
      this.printLayer.batchDraw();
      this.transformer.nodes([node]); this.uiLayer.batchDraw();
    },

    deleteSelected: function () {
      this.transformer.nodes().forEach(function (n) { n.destroy(); });
      this.transformer.nodes([]);
      this.uiLayer.batchDraw(); this.printLayer.batchDraw();
      document.getElementById('gs-delete-selected').style.display = 'none';
    },

    exportAndCart: function () {
      var self = this;
      var btn = document.getElementById('gs-add-to-cart');
      var lbl = document.getElementById('gs-cart-btn-label');
      btn.disabled = true; if (lbl) lbl.textContent = ((window.GS_I18N||{}).saving||'Saving…');
      this.transformer.nodes([]); this.uiLayer.batchDraw();
      var b = this.printBounds;
      var url = this.printLayer.toDataURL({ x: b.x, y: b.y, width: b.w, height: b.h, pixelRatio: 3 });
      this._upload(url, function (imgUrl) { self._addToCart(imgUrl, btn, lbl); });
    },

    _upload: function (dataUrl, cb) {
      var ep = window.GS_UPLOAD_ENDPOINT || '';
      if (!ep) { cb(dataUrl); return; }
      var blob = this._toBlob(dataUrl), fd = new FormData();
      fd.append('image', blob, 'garden-' + Date.now() + '.png');
      fd.append('folder', 'garden-studio');
      fetch(ep, { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) { cb(d.url || d.s3_url || dataUrl); })
        .catch(function () { cb(dataUrl); });
    },

    _addToCart: function (imgUrl, btn, lbl) {
      // Garden Studio scrive sempre sul prodotto "Secret Garden Phone Case"
      // product id 10649880756557, handle secret-garden-phone-case, variant unica.
      var vid = 53836876087629;
      var mn = state.phoneModel.replace(/_/g, ' ');
      PHONE_MODELS.forEach(function (g) { g.models.forEach(function (m) { if (m.id === state.phoneModel) mn = m.name; }); });

      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1, properties: {
          'Phone Model': mn, 'Case Type': 'Tough Case',
          'Base Design': state.baseDesign ? (state.baseDesign.name || state.baseDesign.codice_design) : 'None',
          'Design': imgUrl, 'Text': state.customText || '',
          '_garden_studio': '1', '_studio_version': '5.0'
        }})
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        alert(((window.GS_I18N||{}).cart_error||'Could not add to cart. Please try again.'));
        btn.disabled = false; if (lbl) lbl.textContent = ((window.GS_I18N||{}).add_to_cart||'Add to Cart');
      });
    },

    _toBlob: function (dataUrl) {
      var a = dataUrl.split(','), mime = a[0].match(/:(.*?);/)[1];
      var b = atob(a[1]), n = b.length, u = new Uint8Array(n);
      while (n--) u[n] = b.charCodeAt(n);
      return new Blob([u], { type: mime });
    },

    _bind: function () {
      var self = this;

      document.querySelectorAll('.gs-step__header').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.closest('.gs-step'), open = step.classList.contains('gs-step--open');
          document.querySelectorAll('.gs-step').forEach(function (s) {
            s.classList.remove('gs-step--open');
            var t = s.querySelector('.gs-step__toggle'); if (t) t.textContent = '+';
          });
          if (!open) {
            step.classList.add('gs-step--open');
            var t = btn.querySelector('.gs-step__toggle'); if (t) t.textContent = '×';
          }
        });
      });

      document.getElementById('gs-delete-selected').addEventListener('click', function () { self.deleteSelected(); });

      document.getElementById('gs-cover-flower-thumbs').addEventListener('click', function (e) {
        var thumb = e.target.closest('.gs-cover-flower-thumb');
        if (!thumb) return;
        var idx = parseInt(thumb.dataset.idx, 10);
        var f = state.flowers[idx];
        if (f) self.addFlowerSticker(f.dataUrl);
      });

      document.getElementById('gs-cover-text-add').addEventListener('click', function () {
        var val = document.getElementById('gs-cover-text-input').value.trim();
        var col = (document.querySelector('.gs-text-color-btn.active') || {}).dataset || {};
        col = col.color || '#1a1a1a';
        if (val) { state.customText = val; self.addText(val, state.selectedFont, col); }
      });
      document.getElementById('gs-cover-text-input').addEventListener('keydown', function (e) {
        if (e.key === 'Enter') document.getElementById('gs-cover-text-add').click();
      });

      document.querySelectorAll('.gs-font-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          document.querySelectorAll('.gs-font-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active'); state.selectedFont = btn.dataset.gsFont;
        });
      });
      document.querySelectorAll('.gs-text-color-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          document.querySelectorAll('.gs-text-color-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active'); state.textColor = btn.dataset.color;
        });
      });
      document.querySelectorAll('.gs-model-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          document.querySelectorAll('.gs-model-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active'); state.phoneModel = btn.dataset.gsModel;
          var hm = document.getElementById('gs-header-model'); if (hm) hm.textContent = btn.textContent;
          self.drawPhone();
          /* Reload bases for the new size (some bases differ between iPhone 16+ and older) */
          self._bases = null;
          self.loadBases();
        });
      });
      document.getElementById('gs-add-to-cart').addEventListener('click', function () { self.exportAndCart(); });

      document.querySelectorAll('.gs-tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          document.querySelectorAll('.gs-tab').forEach(function (t) { t.classList.remove('active'); });
          tab.classList.add('active'); self._openSheet(tab.dataset.tab);
        });
      });

      window.addEventListener('resize', function () {
        if (state.phase !== 'cover') return;
        var el = document.getElementById('gs-cover-canvas');
        self.stage.width(el.offsetWidth); self.stage.height(el.offsetHeight);
        self.drawPhone();
      });
    },

    _openSheet: function (tabId) {
      var sidebar = document.getElementById('gs-sidebar');
      if (!sidebar) return;
      var step = sidebar.querySelector('[data-step="' + tabId + '"]');
      if (!step) return;
      var body = step.querySelector('.gs-step__body');
      if (!body) return;
      var sheet = document.getElementById('gs-sheet');
      var content = document.getElementById('gs-sheet-content');
      content.innerHTML = '';
      content.appendChild(body.cloneNode(true));
      sheet.style.display = 'flex';
      setTimeout(function () {
        document.addEventListener('click', function onOut(e) {
          if (!sheet.contains(e.target)) {
            sheet.style.display = 'none';
            document.removeEventListener('click', onOut);
          }
        });
      }, 120);
    }
  };

  /* ══════════════════════════════════════════════════════════
     UI
  ══════════════════════════════════════════════════════════ */

  var UI = {

    init: function () {
      this._renderColors();
      this._renderModelPicker();
      this._renderFonts();
      this._renderTextColors();
      this._bindDrawingControls();
      this._bindGardenButtons();
      this._bindMobileModal();
      this._bindPlantTarget();
    },

    _renderColors: function () {
      var el = document.getElementById('gs-draw-colors');
      if (!el) return;
      el.innerHTML = '';
      DRAW_COLORS.forEach(function (c, i) {
        var btn = document.createElement('button');
        btn.className = 'gs-color-dot' + (i === 0 ? ' active' : '');
        btn.style.backgroundColor = c;
        btn.title = 'Select ' + c;
        btn.setAttribute('aria-label', c);
        btn.addEventListener('click', function () {
          state.drawColor = c; state.isErasing = false;
          document.querySelectorAll('.gs-color-dot').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
        });
        el.appendChild(btn);
      });
    },

    _bindPlantTarget: function () {
      document.querySelectorAll('.gs-plant-target-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          document.querySelectorAll('.gs-plant-target-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          state.plantTarget = btn.dataset.target;
          /* Update plant button label for clarity */
          var plant = document.getElementById('gs-plant-btn');
          if (plant) {
            plant.textContent = state.plantTarget === 'cover' ? '📱 Add to Cover' : '🌱 Plant';
          }
          /* Swap stage: island ↔ cover preview */
          if (state.plantTarget === 'cover') {
            CoverPreview.show();
          } else {
            CoverPreview.hide();
          }
        });
      });
    },

    _bindDrawingControls: function () {
      var resetBtn = document.getElementById('gs-draw-reset');
      if (resetBtn) resetBtn.addEventListener('click', function () { DrawingCanvas.clear(); });

      var plantBtn = document.getElementById('gs-plant-btn');
      if (plantBtn) plantBtn.addEventListener('click', function () {
        if (DrawingCanvas.isEmpty()) return;
        var dataUrl = DrawingCanvas.exportDataUrl();
        if (!dataUrl) return;

        /* Always plant in state — Garden render will be visible if we're on
           the island view; if we're in cover preview the flowers panel will
           reflect it via CoverPreview.refreshFlowers (called inside Garden.plant). */
        Garden.plant(dataUrl);
        DrawingCanvas.clear();

        /* Save to community DB in background (anonymous unless user adds name later) */
        Community.save(dataUrl, '').then(function () { /* no-op */ });

        var m = document.getElementById('gs-mobile-modal');
        if (m && m.style.display !== 'none') m.style.display = 'none';

        /* "📱 Add to Cover" aggiunge solo il fiore sull'anteprima cover (inline) e basta.
           Niente modale né navigazione al builder. L'acquisto avviene con "Add to Cart". */
      });
    },

    _bindGardenButtons: function () {
      document.getElementById('gs-island-reset').addEventListener('click', function () {
        if (state.flowers.length === 0) return;
        if (confirm(((window.GS_I18N||{}).clear_confirm||'Clear all flowers from the garden?'))) Garden.clear();
      });
      var mc = document.getElementById('gs-make-cover');
      if (mc) mc.addEventListener('click', function () { UI._toCover(); });
      var back = document.getElementById('gs-back-to-garden');
      if (back) back.addEventListener('click', function () { UI._toGarden(); });
    },

    _bindMobileModal: function () {
      var openBtn = document.getElementById('gs-mobile-draw');
      var closeBtn = document.getElementById('gs-mobile-modal-close');
      var modal = document.getElementById('gs-mobile-modal');
      var slot = document.getElementById('gs-mobile-modal-slot');
      var panel = document.querySelector('.gs-draw-panel');

      if (!openBtn || !closeBtn || !modal || !slot || !panel) return;

      var inModal = false;

      openBtn.addEventListener('click', function () {
        var area = panel.querySelector('.gs-draw-area');
        var target = panel.querySelector('.gs-plant-target');
        var plant = panel.querySelector('.gs-plant-btn');
        if (area)  slot.appendChild(area);
        if (target) slot.appendChild(target);
        if (plant) slot.appendChild(plant);
        modal.style.display = 'flex';
        inModal = true;
      });

      closeBtn.addEventListener('click', function () {
        if (inModal) {
          var area = slot.querySelector('.gs-draw-area');
          var target = slot.querySelector('.gs-plant-target');
          var plant = slot.querySelector('.gs-plant-btn');
          if (area)  panel.appendChild(area);
          if (target) panel.appendChild(target);
          if (plant) panel.appendChild(plant);
          inModal = false;
        }
        modal.style.display = 'none';
      });

      modal.querySelector('.gs-mobile-modal__backdrop').addEventListener('click', function () {
        closeBtn.click();
      });
    },

    _renderModelPicker: function () {
      var el = document.getElementById('gs-model-groups');
      if (!el) return;
      el.innerHTML = '';
      PHONE_MODELS.forEach(function (g) {
        var wrap = document.createElement('div');
        wrap.className = 'gs-model-group';
        var lbl = document.createElement('div');
        lbl.className = 'gs-model-group__label'; lbl.textContent = g.group;
        wrap.appendChild(lbl);
        var grid = document.createElement('div');
        grid.className = 'gs-model-grid';
        g.models.forEach(function (m) {
          var btn = document.createElement('button');
          btn.className = 'gs-model-btn' + (m.id === state.phoneModel ? ' active' : '');
          btn.dataset.gsModel = m.id; btn.textContent = m.name;
          grid.appendChild(btn);
        });
        wrap.appendChild(grid); el.appendChild(wrap);
      });
    },

    _renderCoverFlowerThumbs: function () {
      var el = document.getElementById('gs-cover-flower-thumbs');
      if (!el) return;
      el.innerHTML = '';
      if (state.flowers.length === 0) {
        el.innerHTML = '<p style="font-size:11px;color:#9a9a9a;margin:0">No flowers yet — go back and draw some.</p>';
        return;
      }
      state.flowers.forEach(function (f, i) {
        var div = document.createElement('div');
        div.className = 'gs-cover-flower-thumb';
        div.dataset.idx = i;
        var img = document.createElement('img');
        img.src = f.dataUrl; img.alt = 'Flower ' + (i + 1);
        div.appendChild(img); el.appendChild(div);
      });
    },

    _renderFonts: function () {
      var el = document.getElementById('gs-font-list');
      if (!el) return;
      el.innerHTML = '';
      [
        { id: 'Inter',           label: 'Sans-Serif' },
        { id: 'Walter Turncoat', label: 'Hand'       },
        { id: 'Georgia',         label: 'Classic'    },
        { id: 'Courier New',     label: 'Mono'       },
        { id: 'Impact',          label: 'Bold'       }
      ].forEach(function (f) {
        var btn = document.createElement('button');
        btn.className = 'gs-font-btn' + (f.id === state.selectedFont ? ' active' : '');
        btn.dataset.gsFont = f.id; btn.style.fontFamily = f.id; btn.textContent = f.label;
        el.appendChild(btn);
      });
    },

    _renderTextColors: function () {
      var el = document.getElementById('gs-text-colors');
      if (!el) return;
      el.innerHTML = '';
      ['#1a1a1a','#ffffff','#e91e63','#166534','#2196f3','#ff9800','#9c27b0','#795548'].forEach(function (c, i) {
        var btn = document.createElement('button');
        btn.className = 'gs-text-color-btn' + (i === 0 ? ' active' : '');
        btn.dataset.color = c; btn.style.background = c;
        if (c === '#ffffff') btn.style.boxShadow = 'inset 0 0 0 1px #ddd';
        el.appendChild(btn);
      });
    },

    updateCount: function () {
      var n = state.flowers.length;
      var hint = document.getElementById('gs-empty-hint');
      if (hint) hint.style.display = n === 0 ? 'block' : 'none';
      var mc = document.getElementById('gs-make-cover');
      if (mc) mc.disabled = false;             /* always enabled — cover works without flowers */
    },

    _toCover: function () {
      state.phase = 'cover';
      var gS = document.getElementById('gs-garden-section');
      var cS = document.getElementById('gs-cover-section');
      gS.classList.add('gs-phase--exit');

      setTimeout(function () {
        gS.style.display = 'none'; gS.classList.remove('gs-phase--exit');
        cS.style.display = 'flex'; cS.classList.add('gs-phase--enter');

        Cover.init();
        /* Wipe any stickers/text from a previous cover session */
        Cover.printLayer.destroyChildren();
        Cover.transformer.nodes([]);
        Cover.uiLayer.batchDraw();
        var del = document.getElementById('gs-delete-selected');
        if (del) del.style.display = 'none';

        UI._renderCoverFlowerThumbs();

        /* Wait for the Tough bases to load, then auto-select the first one
           (so the cover is never empty), then drop the planted flowers on top. */
        Cover.loadBases().then(function (bases) {
          if (bases && bases.length > 0 && !state.baseDesign) {
            var floral = bases.filter(function (b) { return ['290','9075','9109','9116'].indexOf(String(b.codice_design)) >= 0; })[0];
            Cover.selectBase(floral || bases[0]);
          } else if (state.baseDesign) {
            /* Re-apply previously chosen base */
            Cover.selectBase(state.baseDesign);
          }
          /* Place all garden flowers as movable stickers preserving their layout */
          if (state.flowers.length > 0) {
            Cover.addAllGardenFlowers();
          }
        });

        setTimeout(function () { cS.classList.remove('gs-phase--enter'); }, 340);
      }, 270);
    },

    _toGarden: function () {
      state.phase = 'garden';
      var gS = document.getElementById('gs-garden-section');
      var cS = document.getElementById('gs-cover-section');
      cS.classList.add('gs-phase--exit');
      setTimeout(function () {
        cS.style.display = 'none'; cS.classList.remove('gs-phase--exit');
        gS.style.display = 'flex'; gS.classList.add('gs-phase--enter');
        setTimeout(function () { gS.classList.remove('gs-phase--enter'); }, 340);
      }, 270);
    }
  };

  /* ══════════════════════════════════════════════════════════
     INIT
  ══════════════════════════════════════════════════════════ */

  document.addEventListener('DOMContentLoaded', function () {
    UI.init();
    DrawingCanvas.init();
    Garden.init();
    CoverPreview.init();
    Community.init();
    UI.updateCount();
    // Default plant target = Cover (l'utente puo' poi switchare a Garden cliccando il toggle)
    var coverBtn = document.querySelector('.gs-plant-target-btn[data-target="cover"]');
    if (coverBtn) coverBtn.click();
  });

})();
